import React from "react";
import styled from "styled-components";
import IntrinsicElements = JSX.IntrinsicElements;

function Paragraph(props: { config: {lineClamp: number}, tagName: keyof IntrinsicElements, style?: any, className?: string}) {
	const { tagName, config, ...restProps } = props;
	return React.createElement(props.tagName, restProps);
}

interface IStyledProps {
	config: { lineClamp: number; };
}

export default styled(Paragraph)<IStyledProps>`
	${({config}) => config.lineClamp && `
		-webkit-line-clamp: ${config.lineClamp};
		-webkit-box-orient: vertical;
		display: -webkit-box !important;
		margin: 0 !important;
		overflow: hidden;
	`}
`;



// WEBPACK FOOTER //
// ./src/common/views/typographyView/Paragraph.tsx